export default __webpack_public_path__ + "static/marketingImg-694bfe65b981e0a24053d556293354d3.svg";